import { useState, useEffect, useContext, useRef } from "react"
import { ShowLoder, HideLoder, RemoveAllCookies, isValidEmail, CustomParseSafeHtml } from "../../JS/Common";
import { ApiPostCallAuthKey } from "../../JS/Connector";
import { CheckValidation } from "../../Components/Validations";
import ReCAPTCHA from "react-google-recaptcha";
import { LazyLoadImage } from "react-lazy-load-image-component";
import useConfig from "../../Hooks/useConfig";

export function Signup() {
    const { user_type, register_here_link, terms_service_link, privacy_policy_link, organization,
        create_an_organization_account, school, logo
    } = useConfig();
    const formInitialState = {
        FirstName: "",
        LastName: "",
        Email: "",
        SchoolName: ""
    }
    const [FormData, setFormData] = useState(formInitialState);
    const [AlertMsgs, setAlertMsgs] = useState("");
    const [ContinueFlag, setContinueFlag] = useState(0);
    const [AlertColor, setAlertColor] = useState("");
    const [loading, setLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [emailError, setemailError] = useState("");
    const [ShowForm, setShowForm] = useState(1);
    const [isImageLoading, setIsImageLoading] = useState(true);

    var captchasitekey = process.env.REACT_APP_Captcha_Sitekey;
    const recaptcharef = useRef();
    useEffect(() => {
        RemoveAllCookies();
    }, []);

    async function SignUp() {
        var isFormValid = CheckValidation({ formID: 'RegisterForm' });
        if (!isChecked) {
            setErrorMsg("It is required to check our Terms & Conditions above and agree to it.")
            isFormValid = false
        }

        if (FormData.Email != "") {
            if (!isValidEmail(FormData.Email)) {
                setemailError('*Invalid Email')
                isFormValid = false;
            } else {
                setemailError("");
            }
        }

        if (!isFormValid) return;
        setLoading(true);
        const token = await recaptcharef.current.executeAsync();
        var raw = JSON.stringify({
            firstName: FormData.FirstName,
            lastName: FormData.LastName,
            email: FormData.Email,
            schoolName: FormData.SchoolName,
            captcha: token,
            type: user_type
        });
        if (isChecked == true) {
            await ApiPostCallAuthKey("/schools/add", raw).then((result) => {
                if (result == undefined || result == "") {
                    setAlertColor("red");
                    setAlertMsgs("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    if (responseRs.status == "success") {
                        setShowForm(2);
                        setAlertMsgs(responseRs.msg);
                        setAlertColor("green");
                        setFormData(formInitialState);
                    } else {
                        setShowForm(1);
                        setAlertMsgs(responseRs.msg);
                        setContinueFlag(responseRs.flag);
                        setAlertColor("red");
                        recaptcharef.current.reset();
                        if (responseRs.clear_state) {
                            setFormData(formInitialState);
                            setIsChecked(false);
                        }
                    }

                }
            });
        } else {
            setLoading(false);
        }
    }

    async function ContinueSignUp() {
        setLoading(true);
        var raw = JSON.stringify({
            firstName: FormData.FirstName,
            lastName: FormData.LastName,
            email: FormData.Email,
            schoolName: FormData.SchoolName,
        })
        await ApiPostCallAuthKey("/schools/add-school-user", raw).then((result) => {
            if (result == undefined || result == "") {
                setAlertColor("red");
                setAlertMsgs("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setShowForm(2);
                    setAlertMsgs(responseRs.msg);
                    setAlertColor("green")
                } else {
                    setShowForm(1);
                    setAlertMsgs(responseRs.msg);
                    setAlertColor("red")
                }
            }
        });
    }

    return (
        <>
            {loading ? <ShowLoder /> : <HideLoder />}
            <LazyLoadImage src="/images/LoginBg.png" alt="" className="MainDiv-bg-image" />
            <div className="position-relative MainDiv">

                <div className="card mx-auto">
                    <div className="p-4 col-12">
                        {ShowForm == 1 && (
                            <div className="col-12 text-center">
                                <div style={{ color: `${AlertColor}` }} className="font-16">{CustomParseSafeHtml(AlertMsgs)}</div>
                            </div>
                        )}
                        <div className="mt-3">
                            <img
                                src={logo}
                                className={`img-fluid ${isImageLoading ? "d-none" : ""}`}
                                alt="Logo"
                                loading="eager"
                                onLoad={() => setIsImageLoading(false)}
                            />
                        </div>
                        {ShowForm == 1 ?
                            <div className="mt-2 row parent" id="RegisterForm">
                                <div className='col-md-6 pt-4'>
                                    <div className='col-12'>
                                        <input type="text" placeholder="First Name*" autoComplete="off" name='firstname' className="form-control customFormControl" required value={FormData.FirstName}
                                            onChange={(e) => setFormData({ ...FormData, FirstName: e.target.value })} disabled={ContinueFlag == 1} />
                                        <span className="form-text text-start invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div className='col-md-6 pt-4'>
                                    <div className='col-12'>
                                        <input type="text" placeholder="Last Name*" autoComplete="off" name='lastname' className="form-control customFormControl" required value={FormData.LastName}
                                            onChange={(e) => setFormData({ ...FormData, LastName: e.target.value })} disabled={ContinueFlag == 1} />
                                        <span className="form-text text-start invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div className='col-12 pt-4'>
                                    <div className='col-12 text-start'>
                                        <input type="text" placeholder="Email*" autoComplete="off" name='email' className="form-control customFormControl" required value={FormData.Email}
                                            onChange={(e) => setFormData({ ...FormData, Email: e.target.value })} disabled={ContinueFlag == 1} />
                                        <span className="text-start Emailinvalid">{emailError}</span>
                                        <span className="form-text text-start invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div className='col-12 pt-4'>
                                    <div className='col-12'>
                                        <input type="text" placeholder={`${organization} Name*`} autoComplete="off" name='Schoolname' className="form-control customFormControl" required value={FormData.SchoolName}
                                            onChange={(e) => setFormData({ ...FormData, SchoolName: e.target.value })} disabled={ContinueFlag == 1} />
                                        <span className="form-text text-start invalid-feedback">
                                            *required
                                        </span>
                                    </div>
                                </div>
                                <div className='col-12 text-center pt-4 ps-4 centerstyle font-13'>
                                    <input className='form-check-input mt-0 mb-4 me-2 cursor-pointer' disabled={ContinueFlag == 1} type="checkbox" checked={isChecked} onChange={(e) => { setIsChecked(e.target.checked); setErrorMsg('') }} />
                                    <p className="mb-0 text-start">
                                        I have carefully read and agree to the&nbsp;
                                        <a
                                            className="cursor-pointer schoolColorStatus"
                                            style={{ textDecoration: "underline" }}
                                            href={terms_service_link}
                                            target="_blank"
                                        >
                                            Terms of Service&nbsp;
                                        </a>
                                        and&nbsp;
                                        <a
                                            className="cursor-pointer schoolColorStatus"
                                            style={{ textDecoration: "underline" }}
                                            href={privacy_policy_link}
                                            target="_blank"
                                        > Privacy Policy</a></p>
                                </div>
                                <span className="Emailinvalid">{ErrorMsg}</span>


                                {ContinueFlag == 1 ?
                                    <div className="col-12 text-center pt-3">
                                        <button className='CreateButton col-md-3' onClick={ContinueSignUp}>Continue</button>
                                        <label className='ms-2 cursor-pointer' onClick={() => window.location.reload()}><u>Reset</u></label>
                                    </div>
                                    :
                                    <div className='col-12 pt-3'>
                                        <button className='CreateButton col-md-6' onClick={SignUp}>{create_an_organization_account}</button>
                                        <br />
                                        <span style={{ fontSize: "11px" }}>*This is for creating accounts at the {school}-wide level,<br /> rather than for individual accounts.</span>
                                    </div>
                                }
                            </div>
                            :
                            <div className="col-12 text-center pt-5 pb-3">
                                <div style={{ color: 'green' }} className="font-16">{CustomParseSafeHtml(AlertMsgs)}</div>
                            </div>
                        }


                        <div className="row pt-3">
                            <div className="col-md-6 font-13">
                                Register for our demo <a className="cursor-pointer schoolColorStatus" href={register_here_link} target="_blank">
                                    Here
                                </a>
                            </div>
                            <div className="col-md-6 text-center font-13">
                                Already a User?<a className="ps-2 cursor-pointer schoolColorStatus" href="/">Sign In</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center pt-3">
                    <ReCAPTCHA ref={recaptcharef} sitekey={captchasitekey} size="invisible" />
                </div>
            </div>
        </>
    )
}
